module.exports = __webpack_public_path__ + "media/images/landing/top_banner-192e5d00e74e007994558cde445f0c95.jpg";